import React from "react";

type Props = {
  contactInfo: string,
};

export const ContactInfo = ({ contactInfo }: Props) => {
  const infoWithActiveNumbers = (text: string): Array => {
    if (!text) {
      return null;
    }

    const matches = text.match(/([\d]+[ /-]?)+/g) || [];
    const resultArray = [];
    let tail = text;

    matches.forEach((match) => {
      if (match.length < 6) {
        return;
      }

      const [head, newTail] = tail.split(match);
      resultArray.push(head);
      resultArray.push(
        <a href={`tel:${match}`} key={match}>
          {match}
        </a>
      );
      tail = newTail || "";
    });

    resultArray.push(tail);
    return resultArray;
  };

  const results = infoWithActiveNumbers(contactInfo);
  return <span>{results}</span>;
};
